import { AfterViewInit, Directive, ElementRef, NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LbModalComponent, LbModalFooterDirective } from './modal/lb-modal.component';
import { LbPageHeaderComponent } from './page-header/lb-page-header.component';
import { LbStatusBadgeComponent } from './status/lb-status-badge.component';
import { LbEmptyStateComponent } from './empty-state/lb-empty-state.component';
import { LbConfirmHostComponent } from './confirm/lb-confirm-host.component';
import { LbSortHeaderComponent, LbTableComponent } from './table/lb-table.component';
import { LbFilterBarComponent } from './filter-bar/lb-filter-bar.component';
import { LbRowMenuComponent } from './row-menu/lb-row-menu.component';
import { LbDatePipe } from './date/lb-date.pipe';

/**
 * Font Awesome icons are decoration next to text, but their glyph was being read into
 * accessible names (a nav link announced as " Orders"). Hides them from assistive
 * technology unless the icon carries its own label.
 */
@Directive({ selector: 'i.fa, span.fa' })
export class LbDecorativeIconDirective implements OnInit {
  constructor(private el: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    const el = this.el.nativeElement;
    if (!el.hasAttribute('aria-label') && !el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', 'true');
  }
}

let autoId = 0;

/**
 * Many forms use <label>Text</label><input> side by side without for/id, so the label
 * isn't tied to its control (screen readers announce an unnamed field, and tapping the
 * label does nothing). Links such a label to the next unlabelled control in its container.
 */
@Directive({ selector: 'label:not([for])' })
export class LbAutoLabelDirective implements AfterViewInit {
  constructor(private el: ElementRef<HTMLLabelElement>) { }

  ngAfterViewInit(): void {
    const label = this.el.nativeElement;
    if (label.htmlFor || label.querySelector('input, select, textarea')) return;
    const parent = label.parentElement;
    if (!parent) return;
    const selector = label.classList.contains('form-check-label')
      ? 'input[type=checkbox], input[type=radio]'
      : 'input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea';
    const controls = Array.from(parent.querySelectorAll<HTMLElement>(selector));
    const next = controls.find(c => (label.compareDocumentPosition(c) & Node.DOCUMENT_POSITION_FOLLOWING) !== 0
      && !c.hasAttribute('aria-label') && !c.hasAttribute('aria-labelledby')
      && !(c.id && document.querySelector('label[for="' + c.id + '"]')));
    if (!next) return;
    if (!next.id) next.id = 'lb-field-' + (++autoId);
    label.htmlFor = next.id;
  }
}

const DECLARATIONS = [
  LbModalComponent,
  LbModalFooterDirective,
  LbPageHeaderComponent,
  LbStatusBadgeComponent,
  LbEmptyStateComponent,
  LbConfirmHostComponent,
  LbTableComponent,
  LbSortHeaderComponent,
  LbFilterBarComponent,
  LbRowMenuComponent,
  LbDatePipe,
  LbDecorativeIconDirective,
  LbAutoLabelDirective
];

/** The shared back-office component layer (SPEC_LBReq5.md Workstream I). */
@NgModule({
  declarations: DECLARATIONS,
  imports: [CommonModule, FormsModule, RouterModule],
  exports: DECLARATIONS
})
export class SharedModule { }
